// extracted by mini-css-extract-plugin
export default {"femi_Container":"Femi_femi_Container__TqBjs","femi_Wrapper":"Femi_femi_Wrapper__+OWT5","femi_Link":"Femi_femi_Link__CUPBs"};